import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { STATIC_STRINGS } from "../../utils/Constants";
import { Candidate, StepFiveState } from "../types";

const initialState: StepFiveState = {
  topicsData: [],
  fileName: "",
  uploadSuccess: false,
  emailBody: STATIC_STRINGS.EMAIL_BODY,
  candidates: [],
};

const stepFiveSlice = createSlice({
  name: "stepFive",
  initialState,
  reducers: {
    updateEmailBody: (state, action: PayloadAction<string>) => {
      state.emailBody = action.payload;
    },
    addCandidate: (state, action: PayloadAction<Candidate>) => {
      state.candidates.push(action.payload);
    },
    removeCandidate: (state, action: PayloadAction<number>) => {
      state.candidates = state.candidates.filter(
        (candidate, i) => i !== action.payload
      );
    },
    setFileName: (state, action: PayloadAction<string>) => {
      state.fileName = action.payload;
    },
    setUploadSuccess: (state, action: PayloadAction<boolean>) => {
      state.uploadSuccess = action.payload;
    },
    resetStepFive: () => initialState,
  },
});

export const {
  updateEmailBody,
  addCandidate,
  removeCandidate,
  setFileName,
  setUploadSuccess,
  resetStepFive,
} = stepFiveSlice.actions;
export default stepFiveSlice.reducer;
